"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("../constant");
var _constant3 = require("./constant");
var PrimeConfig = {
  desktopImageUrl: _propTypes.string,
  mobileImageUrl: _propTypes.string,
  alt: _propTypes.string,
  dimensions: (0, _propTypes.shape)({
    desktop: (0, _propTypes.shape)({
      width: _propTypes.string,
      height: _propTypes.string
    }),
    mobile: (0, _propTypes.shape)({
      width: _propTypes.string,
      height: _propTypes.string
    })
  })
};
var StandardConfig = {
  desktopImageUrl: (0, _propTypes.arrayOf)(_propTypes.string),
  mobileImageUrl: (0, _propTypes.arrayOf)(_propTypes.string),
  space: _propTypes.string,
  alt: (0, _propTypes.arrayOf)(_propTypes.string)
};
var _default = {
  PropTypes: {
    type: (0, _propTypes.oneOf)(Object.values(_constant3.ADS_PLACEHOLDER_TYPE)),
    primeConfig: (0, _propTypes.shape)(PrimeConfig),
    standardConfig: (0, _propTypes.shape)(StandardConfig),
    viewport: (0, _propTypes.oneOf)(Object.values(_constant2.DEVICE_TYPE)),
    adsToDisplay: _propTypes.number,
    customProperties: _propTypes.object,
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    placeHolderBackground: _propTypes.string,
    displayDefaultAdStandard: _propTypes.bool,
    displayDefaultAdPrime: _propTypes.bool
  },
  DefaultProps: {
    type: _constant3.DEFAULT_TYPE,
    primeConfig: _constant3.DEFAULT_PRIMECONFIG.image,
    standardConfig: _constant3.DEFAULT_STANDARDCONFIG.image,
    viewport: _constant2.DEVICE_TYPE.DESKTOP,
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    displayDefaultAdStandard: true,
    displayDefaultAdPrime: true
  }
};
exports.default = _default;